import * as ElasticAppSearch from '@elastic/app-search-javascript';

export const getSearchClient = (engineName) => {
	// If this is SSR, no point trying.
	if (typeof window === 'undefined') {
		return null;
	}

	// Return any already initialized client for the engine
	if(window?.cj?.appSearchClient?.[engineName]) {
		return window.cj.appSearchClient[engineName];
	}

	// Get app search key or fallabckfo default
	if(!window?.cj?.appSearchSearchKey) {
		console.warn('Using Search Bar without setting App Search Search Key on window! Falling back to default.');
		window.cj.appSearchSearchKey = "search-tdjjtb2ys2955pa8zhmzv794";
	}

	// Get app search base URL or fallabck to default
	if(!window?.cj?.appSearchBaseUrl) {
		console.warn('Using Search Bar without setting App Search Base Url on window! Falling back to default.');
		window.cj.appSearchBaseUrl = "https://de88fbf635ea4d70a288ee0874920b30.ent-search.us-east-1.aws.cloud.es.io";
	}

	// Initialize app search client object if needed
	if(!window?.cj?.appSearchClient) {
		window.cj.appSearchClient = {};
	}

	let appSearchBaseUrl = window.cj.appSearchBaseUrl;

	if (window?.cj?.environment === 'dev') {
		// In dev, use the same hostname at the appsearch port to connect to appSearch/
		// We do it this way so we can test search functionality on devices we can't configure /etc/hosts for
		const appSearchURL = new URL(`//${location.hostname}`, location.href);
		appSearchURL.port = 5402;

		appSearchBaseUrl = appSearchURL.toString().slice(0, -1);
	}

	// Create the client for the specified engine
	window.cj.appSearchClient[engineName] = ElasticAppSearch.createClient({
		searchKey: window.cj.appSearchSearchKey,
		endpointBase: appSearchBaseUrl,
		engineName: engineName
	});

	return window.cj.appSearchClient[engineName];
};

const AppSearchUtil = {
	getSearchClient
};

export default AppSearchUtil;
